import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initializeBackbone } from './app/bootstrap'

// Initialize backend backbone before rendering
initializeBackbone().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}).catch((err) => {
  console.error('Failed to initialize Clarix backbone:', err)
  document.body.innerHTML = '<h1>Failed to initialize application</h1><p>' + err.message + '</p>'
})
